import type { Store } from 'effector'

import { features } from '~/core/flags'

// Reset password state (Nora flag)
export const $resetPasswordEnabled: Store<boolean> = features.get(
  'resetPasswordEnabled',
  true
)
